'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'bring-forward';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f856';
var svgPathData = ['M16 64L16 164.7 187.3 336 288 336c10.4 0 20-3.3 27.8-8.9l-1.5-1.5-288-288-1.5-1.5C19.3 44 16 53.6 16 64zm0 123.3L16 288c0 26.5 21.5 48 48 48L164.7 336 16 187.3zM36.2 24.9l1.5 1.5 288 288 1.5 1.5c5.6-7.8 8.9-17.4 8.9-27.8L336 187.3 164.7 16 64 16c-10.4 0-20 3.3-27.8 8.9zM187.3 16L336 164.7 336 64c0-26.5-21.5-48-48-48L187.3 16z', 'M224 496l224 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-48 0 0-16 48 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-48 16 0 0 48c0 26.5 21.5 48 48 48zM327.1 315.8c5.6-7.8 8.9-17.4 8.9-27.8L336 187.3 164.7 16 64 16c-10.4 0-20 3.3-27.8 8.9l1.5 1.5 288 288 1.5 1.5zm-11.3 11.3l-1.5-1.5-288-288-1.5-1.5C19.3 44 16 53.6 16 64L16 164.7 187.3 336 288 336c10.4 0 20-3.3 27.8-8.9zM164.7 336L16 187.3 16 288c0 26.5 21.5 48 48 48l100.7 0zM0 168L0 64C0 28.7 28.7 0 64 0L288 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 352c-35.3 0-64-28.7-64-64L0 168zM187.3 16L336 164.7 336 64c0-26.5-21.5-48-48-48L187.3 16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBringForward = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;